import { useState } from 'react'
import { User } from 'lucide-react'
import { driverAssets } from '../../../constants/assets'
import type { DriverRecord } from '../../../types'
import { AvailabilityBadge } from './AvailabilityBadge'

type DriverIdentityProps = {
  driver: DriverRecord
}

const isMockAvatar = (url?: string) => {
  if (!url || !url.trim()) return true
  return url.includes('driver-avatar.png')
}

/** Avatar, code, name and phone, with the availability badge pinned to the right. */
export const DriverIdentity = ({ driver }: DriverIdentityProps) => {
  const [imgError, setImgError] = useState(false)
  const showCustomAvatar = Boolean(driver.avatar && !isMockAvatar(driver.avatar) && !imgError)

  return (
    <div className="flex w-full items-start justify-between gap-[8px]">
      <div className="flex min-w-0 flex-1 items-center justify-between gap-[10px]">
        <span className="relative block size-[47px] shrink-0">
          {showCustomAvatar ? (
            <img
              alt={driver.name}
              className="absolute left-0 top-0 block size-[46.857px] max-w-none rounded-full object-cover"
              src={driver.avatar}
              onError={() => setImgError(true)}
            />
          ) : (
            <div className="absolute left-0 top-0 flex size-[46.857px] items-center justify-center rounded-full bg-[#EAEAEA] border border-[#DDDDDD] text-[#757575]">
              <User size={22} className="text-[#666666]" />
            </div>
          )}
          <img
            alt=""
            aria-hidden
            className="absolute left-[33px] top-[33px] block size-[14px] max-w-none"
            src={driverAssets.onlineDot}
          />
        </span>

      <div className="flex min-w-0 flex-1 flex-col items-start gap-[4px]">
        <div className="flex w-full flex-col items-start gap-px font-host font-medium">
          <span className="h-[19.429px] w-full truncate text-[14px] leading-[1.37] tracking-[-0.308px] text-dash-driver-code">
            {driver.code}
          </span>
          <span className="h-[16px] w-full truncate text-[16px] leading-[0.98] tracking-[-0.352px] text-dash-driver-name">
            {driver.name}
          </span>
        </div>

        <a
          className="flex w-full items-center"
          href={`tel:${driver.phone.replace(/\s+/g, '')}`}
          onClick={(event) => event.stopPropagation()}
        >
          <img
            alt=""
            aria-hidden
            className="block size-[17px] max-w-none shrink-0"
            src={driverAssets.phone}
          />
          <span className="whitespace-nowrap font-host text-[12px] font-medium leading-[1.42] text-black">
            {driver.phone}
          </span>
        </a>
      </div>
    </div>

    <AvailabilityBadge availability={driver.availability} />
  </div>
  )
}
